import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { useErrorAlertContext } from 'lib/ErrorAlert';

/**
 * API エラー時の共通スナックバー。
 * lib/ErrorAlert のコンテキストに溜まったエラーを下から順に 1 件ずつ表示する。
 * Material のデフォルトの位置 (bottom-center) で、自動で閉じる + 閉じるボタンあり。
 */
export const ErrorSnackbar = () => {
  const { errors, removeError } = useErrorAlertContext();
  const current = errors[0];

  return (
    <Snackbar
      open={Boolean(current)}
      autoHideDuration={6000}
      onClose={(_, reason) => {
        if (reason === 'clickaway') return;
        if (current) removeError(current.key);
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: { xs: 96 } }}
    >
      {current ? (
        <Alert
          severity="error"
          variant="filled"
          onClose={() => removeError(current.key)}
          sx={{ width: '100%' }}
        >
          {current.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
};
